import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  chains: [],
  chain: null
}

// mutations
export const mutations = {
  [types.SET_CHAINS] (state, chains) {
    state.chains = chains
  },
  [types.SET_CHAIN] (state, chain) {
    state.chain = chain
  },
  [types.FETCH_CHAIN_FAILURE] (state) {
    state.chain = null
  }
}

// actions
export const actions = {
  async fetchChains ({ commit }) {
    try {
      const { data } = await axios.get('/api/value_chains')
      commit(types.SET_CHAINS, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchChain ({ commit }, chain) {
    try {
      const { data } = await axios.get(`/api/value_chains/${chain.id}`)

      commit(types.SET_CHAIN, { chain: data })
    } catch (e) {
      commit(types.FETCH_CHAIN_FAILURE)
    }
  },

  async createChain (context, chain) {
    try {
      await axios.post('/api/value_chains', chain)
      context.dispatch('fetchChains')
    } catch (e) {
      console.log(e)
    }
  },

  async updateChain (context, chain) {
    try {
      await axios.put(`/api/value_chains/${chain.id}`, chain)
      context.dispatch('fetchChains')
    } catch (e) { }
  },

  async deleteChain (context, chain) {
    try {
      await axios.delete(`/api/value_chains/${chain.id}`)
      context.dispatch('fetchChains')
    } catch (e) { }
  }
}

// getters
export const getters = {
  chains: state => state.chains
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/chain.js